'use client';

import { Label } from '@curology/ui-components-web/react/Label';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useEffect, useState } from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { get } from '@/utils/http/client';

const HairValuePropTags = () => {
  const { flowType } = useFlowContext();

  const surveyResponseDataUrl =
    flowType === 'curology-flow-new-treatment-chia'
      ? '/api/data-gateway/surveys/hair-data/get/whatChanges'
      : undefined;

  const defaultTags = [
    'Regrowth',
    'New growth',
    'Preventing hair loss',
    'Thicker, fuller hair',
  ];

  const [tags, setTags] = useState<string[]>(defaultTags);
  const [title, setTitle] = useState<string>('Made for:');

  useEffect(() => {
    if (!surveyResponseDataUrl) {
      return;
    }

    const getDescriptionList = () =>
      get<{
        whatChanges: { formattedName: string }[];
      }>(surveyResponseDataUrl);

    getDescriptionList().then((response) => {
      if (response.data['whatChanges']) {
        const formattedTags = response.data['whatChanges'].map(
          (surveyOption) => surveyOption.formattedName,
        );

        setTitle('Made to treat:');
        setTags(formattedTags);
      }
    });
  }, [surveyResponseDataUrl]);

  return (
    <div>
      <Typography size="body" weight="bold">
        {title}
      </Typography>
      {tags.map((tag) => (
        <Label key={tag} className="cur-mr-2 cur-mt-2">
          {tag}
        </Label>
      ))}
    </div>
  );
};

export default HairValuePropTags;
